import { render } from "./IntegratedExport.vue?vue&type=template&id=64aa9ad4&scoped=true"
import script from "./IntegratedExport.vue?vue&type=script&lang=js"
export * from "./IntegratedExport.vue?vue&type=script&lang=js"

import "./IntegratedExport.vue?vue&type=style&index=0&id=64aa9ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64aa9ad4"]])

export default __exports__